module.exports = __webpack_public_path__ + "static/media/home-students.7da541df.png";